import { lazy } from 'react';
import { msg } from '@/lib/i18n';
import { registerInboxSource } from '@/lib/inbox';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityHref } from '@/ui';
import { registerEntityTab } from '../entityTabs';
import { defineModule } from '../types';
import { commsKeys } from './api';
import { acknowledgementsInbox } from './inbox';
import { conversationRoute, conversationsRoute, publicMessageRoute } from './routes';

/**
 * Comms (server module `comms`): conversations with drivers and users. The IA gives messages no
 * top-level destination — they live where the question is: a coaching case's Messages tab, a
 * driver's Messages tab, the driver's own Me › Messages, and the public read-only link page.
 * `/messages` (list) and `/messages/:id` (one conversation) are the canonical pages that action
 * links, search and the assistant point to; the Coaching Center links to them.
 *
 * Notifications that ask for an acknowledgement wait in the attention inbox (the bell); how a
 * person is notified is set in Me › Notifications (the me module's page, comms' hooks).
 */
export const commsModule = defineModule({
  key: 'comms',
  routes: [conversationsRoute, conversationRoute],
  publicRoutes: [publicMessageRoute],
  nav: [],
  setup() {
    registerEntityTab('driver', {
      key: 'messages',
      label: msg('Messages'),
      order: 70,
      permission: 'comms.message.read',
      module: 'comms',
      component: lazy(() => import('./tabs/DriverMessagesTab')),
    });
    registerEntityHref('conversation', (id) => `/messages/${id}`);
    registerInboxSource(acknowledgementsInbox);
    // Messages are emitted about the driver, the user, or the conversation itself.
    registerInvalidation('driver', () => [commsKeys.all, commsKeys.mine]);
    registerInvalidation('user', () => [commsKeys.mine, ['comms', 'conversations'], commsKeys.pendingAcks, commsKeys.notificationPrefs]);
    registerInvalidation('conversation', () => [commsKeys.all, commsKeys.mine]);
  },
});
